import React from "react";
import { View } from "@instructure/ui-view";
import { Tabs } from "@instructure/ui-tabs";
import ShowDTI from "./components/dti/ShowDTI";

function App() {
  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const bootstrapTokenFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) return;
    localStorage.setItem("token", token);
    params.delete("token");
    const search = params.toString();
    const nextUrl = `${window.location.pathname}${search ? `?${search}` : ""}`;
    window.history.replaceState({}, document.title, nextUrl);
  };

  const handleTabChange = (_event, { index }) => {
    setSelectedIndex(index);
  };

  React.useEffect(() => {
    bootstrapTokenFromUrl();
  }, []);

  return (
    <View as="div" margin="none" padding="none">
      <Tabs margin="none" padding="none" onRequestTabChange={handleTabChange}>
        <Tabs.Panel id="dti-tab" renderTitle="Báo cáo DTI" isSelected={selectedIndex === 0}>
          <ShowDTI />
        </Tabs.Panel>
      </Tabs>
    </View>
  );
}

export default App;
